export default __webpack_public_path__ + "7eee50620b471eef39e6b3c79b8542f6.svg";